import React from "react";
import { Drawer } from "antd";
import { useTranslation } from "react-i18next";

import { TeamMemberTaskProvider } from "../context/TeamMemberTaskContext";
import { TeamMemberTaskList } from "./TeamMemberTaskList";

interface TasksDrawerProps {
  isOpen: boolean;
  toggleDrawer: () => void;
}

export const TasksDrawer: React.FC<TasksDrawerProps> = ({ isOpen, toggleDrawer }) => {
  const { t } = useTranslation("dashboard");

  return (
    <Drawer
      title={t("tasks.title")}
      placement="right"
      onClose={toggleDrawer}
      open={isOpen}
      width={550}
      bodyStyle={{ padding: 16 }}
      className="drawer max-w-full"
    >
      <TeamMemberTaskProvider>
        <TeamMemberTaskList embedded hideCategoryView />
      </TeamMemberTaskProvider>
    </Drawer>
  );
};
